import classNames from 'classnames';
import { ReactNode, useCallback } from 'react';
import { Button, ButtonProps } from 'yoso';
import { useCelect } from '~/components/Form/Celect/Celect.hooks';
import { CelectOptionCheck } from '~/components/Form/Celect/Option/CelectOptionCheck';
import { Option, OptionProps } from '~/components/Form/Option';
import styles from './CelectOption.module.scss';

export type CelectOptionProps = OptionProps<ButtonProps> & {
  icon?: ReactNode;
};
export const CelectOption = ({
  className,
  children,
  value,
  icon = <CelectOptionCheck className={styles.icon} aria-label="icon" />,
  ...props
}: CelectOptionProps) => {
  const { value: celectValue, setValue, closeOnClick, close } = useCelect();
  const handleClick = useCallback(() => {
    if (closeOnClick) {
      close();
    }
    setValue(value);
  }, [close, closeOnClick, setValue, value]);
  const selected = celectValue === value;
  return (
    <Option<ButtonProps>
      as={Button}
      value={value}
      className={classNames(styles.root, className)}
      variant="transparent"
      aria-selected={selected}
      onClick={handleClick}
      {...props}>
      {children}
      {selected && icon}
    </Option>
  );
};
